// extracted by mini-css-extract-plugin
module.exports = {"title":"_0886c","description":"_668bd","row":"a3ccf","content":"fc7da","header":"_0e9a0","section":"_4a31b"};